export default __webpack_public_path__ + "static/media/LeftArrowBlue.ac278a04.svg";